import { TextField } from '@mui/material'
import { isPossiblePhoneNumber } from 'react-phone-number-input'
import CountrySelect from './CountrySelect'
import { parsePhone, countries } from '../../../utils/phone'
import css from './TelefonoInput.module.css'

const TelefonoInput = ({
  className = '',
  name,
  label = 'Teléfono',
  value,
  onChange,
  placeholder = 'Teléfono'
}) => {
  const { countryCode, nationalNumber } = parsePhone(value)
  const selectedCountry = countries.find(c => c.code === countryCode)
  const callingCode = selectedCountry?.callingCode || '+34'

  // Validate the phone number
  const isValid = value && isPossiblePhoneNumber(value)

  const handleCountryChange = newCountryCode => {
    const newCountry = countries.find(c => c.code === newCountryCode)
    const newCallingCode = newCountry?.callingCode || '+34'
    const fullNumber = nationalNumber
      ? `${newCallingCode}${nationalNumber}`
      : `${newCallingCode}`
    const syntheticEvent = { target: { name: name, value: fullNumber } }
    onChange(syntheticEvent, {
      prefijoInternacional: newCallingCode,
      telefono: nationalNumber
    })
  }

  const handleNumberChange = e => {
    const newNumber = e.target.value.replace(/[^0-9]/g, '')
    const fullNumber = newNumber ? `${callingCode}${newNumber}` : ''
    const syntheticEvent = { target: { name: name, value: fullNumber } }
    onChange(syntheticEvent, {
      prefijoInternacional: callingCode,
      telefono: newNumber
    })
  }

  return (
    <div className={`${className} ${css.container}`}>
      <label htmlFor={name} className={css.label}>
        {label}
      </label>
      <div className={css.inputRow}>
        <CountrySelect
          name={`${name}-country`}
          value={countryCode}
          onChange={handleCountryChange}
        />
        <TextField
          id={name}
          name={name}
          variant='standard'
          value={nationalNumber}
          onChange={handleNumberChange}
          placeholder={placeholder}
          className={css.phoneInput}
          error={Boolean(nationalNumber && !isValid)}
          InputProps={{
            startAdornment: <span className={css.prefix}>{callingCode}</span>
          }}
        />
      </div>
    </div>
  )
}

export default TelefonoInput
